<template>
    <div>
        
        <!-- Filter Start -->
        <custom-filter
            :getFilterOnStart="true"
            @filterChange="changeFilter"
        ></custom-filter>
        <!-- Filter End -->
        
        <!-- Chart Start -->
         <div class="row mt-4">
            <div class="col">
                <div class="innerBox">
                    <div class="row">
                        <div class="col-md-8">
                            <h5 class="elegant--sub-title">
                                Checking Report
                                <i
                                    class="fas fa-info-circle"
                                    id="checking-report"
                                ></i>
                                <b-popover target="checking-report" triggers="hover" placement="top">
                                    <template #title>Checking Report</template>
                                    <div v-html="tooltip.checking_report"></div>
                                </b-popover>
                            </h5>
                        </div>
                        <div class="col-md-2">
                            <MultiSelect 
                                v-model="filter.labelmaker"
                                :options="options.labelMaker"
                                placeholder="All Label Makers"
                                class="elegant-multiselect"
                                />
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-elegant-download">Download Excel <i class="fas fa-download"></i></button>
                        </div>
                    </div>
                    <checking-report-chart
                        v-if='data.checkingReportChart'
                        :data="data.checkingReportChart"
                        :filter="filter"
                    ></checking-report-chart>
                    <div v-else class="text-center mt-5 mb-5">
                        <h2 class="pt-5 pb-5">Loading...</h2>
                    </div>
                </div>
            </div>
         </div>
        <!-- Chart End -->

        <div class="innerBox mt-4">
            <div class="row">
                <div class="col-md-8">
                    <h5 class="elegant--sub-title">
                        Report by Purchase Order
                        <i
                            class="fas fa-info-circle"
                            id="history-report"
                        ></i>
                        <b-popover target="history-report" triggers="hover" placement="top">
                            <template #title>Customer Report</template>
                            <div v-html="tooltip.report_by_purchase_order"></div>
                        </b-popover>
                    </h5>
                </div>
            </div>

            <report-by-po
                v-if='data.reportByPo'
                :data="data.reportByPo"
            ></report-by-po>
            <div v-else class="text-center mt-5 mb-5">
                <h2 class="pt-5 pb-5">Loading...</h2>
            </div>
        </div>

        <!-- Table Start -->
        <div class="innerBox mt-4">
            <!-- <div class="row">
                <div class="col-md-10">
                    <h5 class="elegant--sub-title">History Report</h5>
                </div>
                <div class="col-md-2">
                    <button class="btn btn-elegant-download">Download Excel <i class="fas fa-download"></i></button>
                </div>
            </div> -->
            <div class="mt-3">
                <vue-universal-table
                    api_url="api/reports/labelmaker-history"
                    :fields="vue_universal_table.fields"
                    :filter="vue_universal_table.filter"
                    :update="vue_universal_table.update"
                    :special_buttons="['exportToXlsx']"
                    :process_data="vue_universal_table.process_data"
                    :export_config="vue_universal_table.export_config"
                    :infinite_scroll="true"
                ></vue-universal-table>
            </div>
        </div>
        <!-- Table End -->
        
    </div>
</template>

<script>
    import qs from 'qs'
    import customFilter from '@/components/filter/customFilter'
    // import highlightStats from './children/HighlightStats'

    
    import checkingReportChart from './children/checkingReportChart.vue'

    import reportByPo from './children/LabelReportByPO'

    export default {
        metaInfo : {
            title : 'Report - Label Maker'
        },
        data () {
            return {
                tooltip : this.$store.state.tooltip.reports,
                filter : {
                    labelmaker : null,
                },
                data : {
                    checkingReportChart :null,
                    reportByPo : null,
                },
                options : {
                    labelMaker : this.$store.getters.getLabelMaker,
                },
                vue_universal_table : {
                    export_config : {
                        name : 'Report Label Maker Download',
                        type : 'xlsx',
                        all : true,
                    },
                    fields : [
                        {title:"Kode QR", variable:"qrcode"},
                        {title:"Serial No", variable:"serial_number"},
                        {title:"Label Maker", variable:"label_maker"},
                        {title:"Variant", variable:"product_name"},
                        {title:"Volume", variable:"volume"},
                        {title:"Status", variable:"status", style_condition : {
                            'Success' : 'color:green; font-weight: bold',
                            'Reject' : 'color:red; font-weight: bold',
                            'Not Found' : 'color:grey; font-weight: bold',
                            'Double Scan' : 'color:orange; font-weight: bold'
                        }},
                        {title:"Date", variable:"scan_date", date_format:'DD MMM YYYY HH:mm:ss'},
                    ],
                    filter : {
                        labelmaker : null,
                    },
                    update : 0,
                    process_data : `
                        for (var i in data) {
                            data[i].label_maker = data[i].label_maker ? data[i].label_maker : '-'
                            data[i].product_name = data[i].product_name ? data[i].product_name : '-'
                            data[i].volume = data[i].volume ? (parseInt(data[i].volume))/1000 + ' Lt' : '-'
                            data[i].qrcode = data[i].qrcode ? data[i].qrcode : '-'
                            data[i].serial_number = data[i].serial_number ? data[i].serial_number : '-'
                            data[i].status = data[i].status ? data[i].status : '-'
                            data[i].scan_date = data[i].scan_date ? data[i].scan_date : '-'
                        }
                    `
                }
            }
        },
        components : {
            customFilter,
            // highlightStats,
            
            checkingReportChart,
            reportByPo,
        },
        mounted () {
            this.fetchData();
        },
        watch : {
            'filter' : {
                deep : true,
                handler : 'fetchData',
            },
        },
        methods : {
            changeFilter (filter) {
                for (var i in filter) {
                    this.filter[i] = filter[i];
                    this.vue_universal_table.filter[i] = filter[i];
                }

                //Delete unnecessary filter for the table
                delete this.vue_universal_table.filter.filter;
                // console.log(this.filter);
                this.fetchData();
                this.vue_universal_table.update++;
            },
            fetchData () {
                //Reset All Data to null
                for (var i in this.data) this.data[i] = null;

                //Remove filter from filter
                let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                delete filterlessFilter.filter;

                //Get Activation Report
                this.$http.get(`/api/reports/labelmaker-overview?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.checkingReportChart = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get Report By PO Order
                this.$http.get(`/api/reports/labelmaker-po-report?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.reportByPo = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .table td, .table th{
        text-align: center;
    }
</style>